'use client';

import React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

interface UserLocationMarkerProps {
  lat: number;
  lng: number;
}

const UserLocationMarker = ({ lat, lng }: UserLocationMarkerProps) => (
  <AdvancedMarker position={{ lat, lng }} zIndex={200}>
    <div
      className="relative flex h-5 w-5 items-center justify-center"
      aria-label="Your location"
      data-testid="user-location-marker"
    >
      {/* Pulsing ring */}
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blue-500 opacity-50" />
      {/* Solid dot */}
      <span className="relative inline-flex h-3 w-3 rounded-full bg-blue-600 border-2 border-white shadow-md" />
    </div>
  </AdvancedMarker>
);

export default UserLocationMarker;
